<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M1 9C1 9 3.90909 3 9 3C14.0909 3 17 9 17 9C17 9 14.0909 15 9 15C3.90909 15 1 9 1 9Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      d="M9 11.25C10.205 11.25 11.1818 10.2426 11.1818 9C11.1818 7.75736 10.205 6.75 9 6.75C7.79502 6.75 6.81818 7.75736 6.81818 9C6.81818 10.2426 7.79502 11.25 9 11.25Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'EyeIcon',
  };
</script>
